import { useMutation } from 'react-query'
import { patchResetPassword } from 'src/reset/service/patchResetPassword'
import { sendEventType } from 'src/shared/components/ResetPassword'
import { TokenModel } from './model'

export default function useResetPassword(send: sendEventType) {
  return useMutation<unknown, unknown, TokenModel, unknown>(patchResetPassword, {
    onSuccess: () => {
      send({ type: 'RESET_SUCCESS' })
    },
  })
}
